"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var microsoftTeams = require("@microsoft/teams-js");
var serventias_api_1 = require("../../../api/serventias-api");
var meetings_api_1 = require("../../../api/meetings-api");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var status_queue_1 = require("../../../constants/status-queue");
var post_meeting_panel_1 = require("../post-meeting-panel/post-meeting-panel");
var react_i18next_1 = require("react-i18next");
require("./in-meeting-panel.scss");
var moment = require('moment');
var InMeetingPanel = /** @class */ (function (_super) {
    __extends(InMeetingPanel, _super);
    function InMeetingPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.meetingId = null;
        _this.frameContext = null;
        _this.inMeetingSidePanel = "sidePanel";
        _this.postMeetingPanel = "content";
        /**
         * Get App Configs
         * */
        _this.getAppConfig = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getAppConfig()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                appConfigs: response.data,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getMeetingQueueData = function (meetingId) { return __awaiter(_this, void 0, void 0, function () {
            var response, responsePhoto, taskInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getQueueDataByMeetingId(meetingId)];
                    case 1:
                        response = _a.sent();
                        if (!(response.status === 200 && response.data)) return [3 /*break*/, 3];
                        return [4 /*yield*/, serventias_api_1.getCurrentUserPhoto(response.data.atendenteId)];
                    case 2:
                        responsePhoto = _a.sent();
                        this.setState({
                            meetingData: response.data,
                            atendentePhoto: responsePhoto.data,
                            loading: false,
                        });
                        if (response.data.status == status_queue_1.default.atendimentoInativo &&
                            this.frameContext == this.inMeetingSidePanel) {
                            microsoftTeams.initialize();
                            taskInfo = {
                                title: this.localize('AtendimentoExpirado'),
                                url: window.location.origin + "/in-meeting-alert?commandContext=task",
                                height: 150,
                                width: 400,
                            };
                            clearInterval(this.state.interval);
                            microsoftTeams.tasks.startTask(taskInfo);
                        }
                        else if (response.data.status == status_queue_1.default.atendimentoEncerrado) {
                            clearInterval(this.state.interval);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.encerrar = function (item) {
            item.loadingEndMeeting = true;
            serventias_api_1.endCall(item.id).then(function (response) {
                item.loadingEndMeeting = false;
                _this.getMeetingQueueData(_this.meetingId);
            });
        };
        _this.statusColor = function (status) {
            if (status == status_queue_1.default.atendimentoIniciado)
                return 'blue';
            else if (status == status_queue_1.default.emAtendimento)
                return 'green';
            else
                return 'red';
        };
        _this.getTempoEspera = function (history) {
            var itemEmAtendimento = history.find(function (e) { return e.status == status_queue_1.default.emAtendimento; });
            var itemNaFila = history.find(function (e) { return e.status == status_queue_1.default.naFila; });
            var tempoEsperaMin = moment.utc(moment(itemEmAtendimento === null || itemEmAtendimento === void 0 ? void 0 : itemEmAtendimento.created).diff(moment(itemNaFila === null || itemNaFila === void 0 ? void 0 : itemNaFila.created))).format("mm");
            var tempoEsperaSec = moment.utc(moment(itemEmAtendimento === null || itemEmAtendimento === void 0 ? void 0 : itemEmAtendimento.created).diff(moment(itemNaFila === null || itemNaFila === void 0 ? void 0 : itemNaFila.created))).format("ss");
            return [tempoEsperaMin, tempoEsperaSec].join('m') + 's';
        };
        _this.getLabelStatusLocale = function (status) {
            if (status) {
                if (status == status_queue_1.default.naFila)
                    return _this.localize("NaFila");
                else if (status == status_queue_1.default.atendimentoIniciado)
                    return _this.localize("AtendimentoIniciado");
                else if (status == status_queue_1.default.emAtendimento)
                    return _this.localize("EmAtendimento");
                else if (status == status_queue_1.default.atendimentoEncerrado)
                    return _this.localize("AtendimentoEncerrado");
                else if (status == status_queue_1.default.atendimentoInativo)
                    return _this.localize("AtendimentoInativo");
                else if (status == status_queue_1.default.atendimentoCancelado)
                    return _this.localize("AtendimentoCancelado");
            }
        };
        _this.localize = _this.props.t;
        _this.state = {
            appConfigs: null,
            meetingData: [],
            loading: true,
            interval: null,
            atendentePhoto: "",
        };
        return _this;
    }
    InMeetingPanel.prototype.componentDidMount = function () {
        var _this = this;
        microsoftTeams.initialize();
        microsoftTeams.getContext(function (context) {
            var meetingId = window.btoa("1*" + context.userObjectId + "*0**" + context.chatId);
            _this.meetingId = meetingId;
            _this.frameContext = context.frameContext;
            _this.getAppConfig();
            _this.getMeetingQueueData(meetingId);
            if (_this.frameContext == _this.inMeetingSidePanel) {
                var interval = setInterval(function () { return _this.getMeetingQueueData(meetingId); }, 10000);
                _this.setState({ interval: interval });
            }
        });
    };
    InMeetingPanel.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (this.state.loading) {
            return (React.createElement(react_northstar_1.Segment, null,
                React.createElement(react_northstar_1.Loader, null)));
        }
        else if (this.frameContext == this.inMeetingSidePanel) {
            return (React.createElement(react_northstar_1.Flex, { className: "in-meeting-panel", gap: "gap.medium", column: true },
                React.createElement(react_northstar_1.Flex, { className: "panel-header", vAlign: "center", gap: "gap.medium" },
                    React.createElement(react_northstar_1.Image, { className: "logo-img", circular: true, src: "/images/logo.png" }),
                    React.createElement(react_northstar_1.Text, { className: "title", size: "larger", content: this.localize("Atendimento") + " #" + ((_a = this.state.meetingData) === null || _a === void 0 ? void 0 : _a.id.substr(((_b = this.state.meetingData) === null || _b === void 0 ? void 0 : _b.id.length) - 6)) })),
                React.createElement(react_northstar_1.Flex, { className: "status-bar-" + this.statusColor((_c = this.state.meetingData) === null || _c === void 0 ? void 0 : _c.status), gap: "gap.smaller", column: true },
                    React.createElement(react_northstar_1.Flex, { gap: "gap.medium" },
                        React.createElement(react_northstar_1.Text, { weight: "semibold", content: this.localize("Status") }),
                        React.createElement(react_northstar_1.Text, { className: ((_d = this.state.meetingData) === null || _d === void 0 ? void 0 : _d.status) == status_queue_1.default.atendimentoInativo ? "status-text" : "", content: this.getLabelStatusLocale((_e = this.state.meetingData) === null || _e === void 0 ? void 0 : _e.status) })),
                    React.createElement(react_northstar_1.Text, { size: "smaller", content: this.localize("UltimaAtualizacao") + " - " + moment.utc((_f = this.state.meetingData) === null || _f === void 0 ? void 0 : _f.updated).format("HH:mm:ss") })),
                React.createElement(react_northstar_1.Flex, { className: "details", gap: "gap.small", vAlign: "center" },
                    React.createElement(react_northstar_1.Text, { weight: "semibold", size: "small", content: this.localize("Detalhes") }),
                    React.createElement(react_icons_northstar_1.ChevronDownMediumIcon, null)),
                React.createElement(react_northstar_1.Segment, { className: "panel-content", color: "black" },
                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", column: true },
                        React.createElement(react_northstar_1.Flex, { gap: "gap.smaller" },
                            React.createElement(react_northstar_1.Text, { className: "title-width", size: "small", content: this.localize("SolicitadoEm") }),
                            React.createElement(react_northstar_1.Text, { className: "content-width", size: "small", content: moment((_h = (_g = this.state.meetingData) === null || _g === void 0 ? void 0 : _g.OnlineMeetingData) === null || _h === void 0 ? void 0 : _h.startDateTime).format("HH:mm:ss") })),
                        ((_j = this.state.meetingData) === null || _j === void 0 ? void 0 : _j.status) == status_queue_1.default.atendimentoEncerrado &&
                            React.createElement(React.Fragment, null,
                                React.createElement(react_northstar_1.Divider, null),
                                React.createElement(react_northstar_1.Flex, { gap: "gap.smaller" },
                                    React.createElement(react_northstar_1.Text, { className: "title-width", size: "small", content: this.localize("EncerradoEm") }),
                                    React.createElement(react_northstar_1.Text, { className: "content-width", size: "small", content: moment.utc((_k = this.state.meetingData) === null || _k === void 0 ? void 0 : _k.History.find(function (e) { return e.status == status_queue_1.default.atendimentoEncerrado; }).created).format("HH:mm:ss") }))),
                        ((_l = this.state.meetingData) === null || _l === void 0 ? void 0 : _l.assunto) &&
                            React.createElement(React.Fragment, null,
                                React.createElement(react_northstar_1.Divider, null),
                                React.createElement(react_northstar_1.Flex, { gap: "gap.smaller" },
                                    React.createElement(react_northstar_1.Text, { className: "title-width", size: "small", content: this.localize("Assunto") }),
                                    React.createElement(react_northstar_1.Text, { className: "content-width", size: "small", content: (_m = this.state.meetingData) === null || _m === void 0 ? void 0 : _m.assunto }))),
                        (((_o = this.state.meetingData) === null || _o === void 0 ? void 0 : _o.status) == status_queue_1.default.emAtendimento ||
                            ((_p = this.state.meetingData) === null || _p === void 0 ? void 0 : _p.status) == status_queue_1.default.atendimentoEncerrado) &&
                            React.createElement(React.Fragment, null,
                                React.createElement(react_northstar_1.Divider, null),
                                React.createElement(react_northstar_1.Flex, { gap: "gap.smaller" },
                                    React.createElement(react_northstar_1.Text, { className: "title-width", size: "small", content: this.localize("TempoEspera") }),
                                    React.createElement(react_northstar_1.Text, { className: "content-width", size: "small", content: this.getTempoEspera((_q = this.state.meetingData) === null || _q === void 0 ? void 0 : _q.History) }))))),
                ((_r = this.state.meetingData) === null || _r === void 0 ? void 0 : _r.status) == status_queue_1.default.emAtendimento &&
                    React.createElement(react_northstar_1.Button, { icon: React.createElement(react_icons_northstar_1.LeaveIcon, null), content: this.localize("Encerrar"), iconPosition: "before", primary: true, fluid: true, onClick: function () { return _this.encerrar(_this.state.meetingData); } })));
        }
        else {
            return (React.createElement(post_meeting_panel_1.default, { meetingId: this.meetingId, meetingData: this.state.meetingData, atendentePhoto: this.state.atendentePhoto }));
        }
    };
    return InMeetingPanel;
}(React.Component));
var inMeetingPanelWithTranslation = react_i18next_1.withTranslation()(InMeetingPanel);
exports.default = inMeetingPanelWithTranslation;
//# sourceMappingURL=in-meeting-panel.js.map